<template>
  <div class="group-action-for-all-customers-component">
    <a class="btn btn-primary btn-md" @click="open = true">{{ groupAction.title }}</a>
    <a-modal v-model="open" :footer="null" width="600" @cancel="reset">
      <a-list v-if="!atSettings">
        <a-list-item>
          <a-list-item-meta :title="groupAction.title || 'Titel niet bekend'">
            <span slot="description">
              Aantal klanten waarop de actie uitgevoerd wordt: {{ groupAction.count }}
              <span v-if="success" class="text-success">
                <br>
                <small>
                  De actie is gestart. Je kunt deze pagina nu verlaten.
                </small>
              </span>
            </span>
          </a-list-item-meta>
          <span slot="actions">
            <a-button size="small" @click="act(groupAction.tag)" :loading="loading"
                      :disabled="success"
                      v-if="groupAction.settings === null" type="primary">
              Start actie
            </a-button>
            <a-button size="small" @click="goToSettings(groupAction, groupAction.tag)"
                      :loading="loading"
                      :disabled="success" v-else>
              Volgende
            </a-button>
          </span>
        </a-list-item>
      </a-list>
      <GroupActionSettingsComponent @open="atSettings = $event.value" :open="!!atSettings" :settings="settings"
                                    :loading="loadingSettings" :errors="errors"
                                    @act="act(atSettings, $event.value)"></GroupActionSettingsComponent>
    </a-modal>
  </div>
</template>

<script>
import groupActionApi from "~/api/group_action.js";
import GroupActionSettingsComponent from "./GroupActionSettingsComponent";

export default {
  name: "GroupActionForAllCustomersComponent",
  components: { GroupActionSettingsComponent },
  props: {
    actionTag: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      open: false,
      success: false,
      groupAction: [],
      loading: false,
      loadingGroupAction: false,
      loadingSettings: false,
      atSettings: null,
      settings: null,

      errors: {}
    };
  },
  computed: {
    title() {
      switch (this.actionTag) {
        case "update-customer-salutation":
          return "Aanhef updaten";
        case "update-customer-title":
          return "Titulatuur updaten";
      }
    }
  },
  methods: {
    async act(actionName, settings) {
      this.loading = true;
      try {
        await groupActionApi.startGroupActionByModel("customer", actionName, settings);

        this.$notification["success"]({
          message: "De actie is begonnen."
        });
        this.success = true;

        this.reset();
      } catch (e) {
        this.$notification["error"]({
          message: "Er ging iets mis",
          description: "Er ging iets fout met het opstarten van de actie"
        });

        this.errors = e.response.data.error.errors;
      } finally {
        this.loading = false;
      }
    },
    async getGroupAction() {
      this.loadingGroupAction = true;
      try {
        this.groupAction = await groupActionApi.getGroupActionByActionTag(this.actionTag);
      } catch (e) {
        this.$notification["error"]({
          message: "Er ging iets mis",
          description: "Er ging iets fout met het ophalen van de actie"
        });
      } finally {
        this.loadingGroupAction = false;
      }
    },
    async goToSettings(action, key) {
      this.atSettings = key;
      this.settings = action.settings;
    },
    reset() {
      this.settings = null;
      this.atSettings = null;
      this.errors = {};
      this.open = false;
    }
  },
  mounted() {
    this.getGroupAction();
  }
};
</script>
